<ng-container *ngIf="{ onMenu: showTimeline && !!dateEntries?.length && isOnMenu && showDatesMenu && currentPage !=='timeline' } as vars">
 <top-menu 
    *ngIf=" ready && !mobileView && !viewMySchedule && (!!dateEntries?.length || currentPage ==='timeline')"
    [showPrint]="currentPage ==='timeline'"
    [showFilter]="currentPage ==='timeline'"
    [showZoom]="!vars.onMenu"
    [visibleItems]="(onsiteBuilder?.ossView?.length || 0) - (onsiteBuilder?.hiddenSchedules?.size || 0)"
    [totalItems]="onsiteBuilder?.ossView?.length || 0"
    (editVisible)="onsiteBuilder.editVisibleSchedules()"    
    (filter)="filter()"
  ></top-menu>
  <mobile-menu *ngIf="mobileView">
    <dropdown class="top-right" *ngIf="!!onsiteBuilder?.scheduleOptions?.length" 
      [selections]="onsiteBuilder.scheduleOptions" 
      [selected]="onsiteBuilder.scheduleOptions | findById:onsiteBuilder.mobileScheduleId" 
      (select)="$event.id === 'new' ? onsiteBuilder.addSchedule() : onsiteBuilder.mobileScheduleId = $event.id"
    ></dropdown>
    <div class="lower-right" *ngIf="currentPage==='timeline'">
      <icon class="timelineMode" [ngClass]="{active: onsiteTimeline?.timelineMode == 'multiple'}" (click)="onsiteTimeline?.toggleView('multiple')" icon="column_multi_24px"></icon>
      <icon class="timelineMode" [ngClass]="{active: onsiteTimeline?.timelineMode == 'single'}" (click)="onsiteTimeline?.toggleView('single')" icon="column_single_24px"></icon>
    </div>
  </mobile-menu>
  <message-panel [message]="message" [passive]="true"></message-panel>
  <div class="no_entry" *ngIf="!dateEntries?.length && !!activitiesLoaded && !viewMySchedule">
    <loader-pane-fragment [trace]="traceNames.viewOnSiteScheduleDate"></loader-pane-fragment>
    <p>You don't have any room/locations with dates.</p>	
    <p>Create a room/location and give it a date, then you will be able to use the on site schedule.</p>
  </div>
  <div class="no_entry" *ngIf="!showTimeline && !!activitiesLoaded && viewMySchedule">
    <loader-pane-fragment [trace]="traceNames.viewMySchedule"></loader-pane-fragment>
    <p>You are not tagged in any activities or sessions with dates</p>
  </div>
  <div class="wrap680" *ngIf="vars.onMenu">
    <div class="entries box" *ngFor="let entries of dateEntries; trackBy: trackByFn;">
      <div class="entry" *ngFor="let entry of entries; trackBy: trackByFn;" (click)="showSchedule(entry)">
        <div class="dd" [appdatetime]="entry.date" format="EEEE d MMMM y"></div>
      </div>
    </div>
  </div>
  <zoom-wrapper *ngIf="showTimeline && !!dateEntries?.length">
    <loader-pane-fragment [trace]="traceNames.viewOnSiteScheduleDate"></loader-pane-fragment>
    <onsite-timeline 
      *ngIf="currentPage==='timeline'"
      #onsiteTimeline
      [mySchedule]="viewMySchedule" 
      [timelineViews]="timelineViews" 
      (emitProgramDetail)="openProgramDetail(null, $event)" 
      (emitBrickDetail)="openBrickDetail($event)" 
      (openFilters)="filter()" 
      (close)="hideSchedule()">
    </onsite-timeline>
    <onsite-builder 
      *ngIf="!isOnMenu && currentPage=='build'"
      #onsiteBuilder
      [readonly]="permissionsService.readonly[page_name] || readonly"  
      [dateId]="dateId" 
      [date]="date" 
      [hasDatesMenu]="showDatesMenu"
      (emitProgramDetail)="openProgramDetail(null, $event)" 
      (emitSessionDetail)="openSessionDetail($event)" 
      (close)="hideSchedule()">
    </onsite-builder>
  </zoom-wrapper>  
</ng-container>
